import * as React from 'react';
import type { SVGProps } from 'react';

const ClockSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Chunk/Clock">
      <path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M8 16.0001C12.4183 16.0001 16 12.4184 16 8.00012C16 3.58184 12.4183 0.00012207 8 0.00012207C3.58172 0.00012207 0 3.58184 0 8.00012C0 12.4184 3.58172 16.0001 8 16.0001ZM7 3.00012V8.41434L10.2929 11.7072L11.7071 10.293L9 7.58591V3.00012H7Z" fill="#616061"/>
    </g>
  </svg>
);

export default ClockSvg;